import { RootState } from 'store/store';

export const selectAuthFlowType = (state: RootState) => state.Auth.authFlowType;
